import { render } from "./QuestionnaireThanksPage.vue?vue&type=template&id=10d00f94&scoped=true"
import script from "./QuestionnaireThanksPage.vue?vue&type=script&lang=js"
export * from "./QuestionnaireThanksPage.vue?vue&type=script&lang=js"

import "./QuestionnaireThanksPage.vue?vue&type=style&index=0&id=10d00f94&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d00f94"]])

export default __exports__